import { SvgIcon, SxProps } from "@mui/material";
import CommentSvg from "jsx:../../../Images/Icons/FontAwesome/light/comment.svg";

export function CommentIcon(props: SxProps) {
    return <SvgIcon component={CommentSvg} inheritViewBox sx={props} />;
}
